import ApiDocumentationIframe from './ApiDocumentationIframe';
export default ApiDocumentationIframe;



// WEBPACK FOOTER //
// ./src/components/ApiDocumentation/ApiDocumentationIframe/index.js